import { render, staticRenderFns } from "./UserCenter.vue?vue&type=template&id=fd37d0ac&scoped=true&"
import script from "./UserCenter.vue?vue&type=script&lang=ts&"
export * from "./UserCenter.vue?vue&type=script&lang=ts&"
import style0 from "./UserCenter.vue?vue&type=style&index=0&id=fd37d0ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd37d0ac",
  null
  
)

export default component.exports